import { Injectable, signal } from '@angular/core';

/**
 * This service in intended to help manage the memory of the app-popover-buttons component
 */
@Injectable({
  providedIn: 'root'
})
export class PopoverButtonsService {

  closeHandler: ((event: Event) => void) | undefined = undefined;

  closePopoverButtons = (event: Event) => {
    this.closeHandler?.(event);
  };

  constructor() {
    document.addEventListener('click', this.closePopoverButtons);
  }
}
